<pp-page-header *ngIf="createAccountActivated || forgotPasswordActivated"
                     [ngClass]="{'hide-back': hideBackButton, 'hide-close': hideCloseButton}"
                     [titleToTranslate]="createAccountActivated ? 'CreateAccount.Login.PP' : 'ChangePassword.Login.PP'"
                     (backClick)="handleBack()"
                     (closeClick)="backToLogin()"></pp-page-header>

<div class="content">
  <app-login [ngClass]="{'hidden': !LoginDisplayed}"
                      #Login
                      (createAccount)="newAccount()"
                      (forgotPassword)="doForgotPassword()" >
  </app-login>

  <app-patient-search [ngClass]="{'hidden': !patientSearchDisplayed}"
                      #PatientSearch
                      (next)="searchPatientDone($event)"
                      (error)="errorDuringPatientSearch($event)">
  </app-patient-search>

  <app-patient-details *ngIf="createAccountActivated"
                       [ngClass]="{'hidden': !patientDetailsDisplayed}"
                       #PatientDetails
                       (back)="backToSearch($event)"
                       (next)="continueToOneTimeCodeGeneration($event)">
  </app-patient-details>

  <app-one-time-code *ngIf="createAccountActivated || forgotPasswordActivated"
                     [ngClass]="{'hidden': !oneTimeCodeDisplayed}"
                     #OneTimeCode
                     (back)="backFromOneTimeCode($event)"
                     (next)="oneTimeCodeValidationDone($event)"
                     (error)="errorDuringOneTimeCodeValidation($event)">
  </app-one-time-code>

  <app-patient-account *ngIf="createAccountActivated || forgotPasswordActivated"
                       [ngClass]="{'hidden': !patientAccountDisplayed}"
                       #PatientAccount
                       (back)="backFromPatientAccount($event)"
                       (accountCreated)="continueToAccountCreationSummary($event)"
                       (passwordChanged)="continueToPasswordChangedSummary($event)"
                       (error)="errorDuringAccountCreationOrForgotPassword($event)">
  </app-patient-account>

  <app-summary *ngIf="createAccountActivated || forgotPasswordActivated"
               [ngClass]="{'hidden': !summaryDisplayed}"
               #Summary
               (backToLogin)="backToLogin()"
               (backToSearch)="backToSearchFromSummary($event)"
               (backToOneTimeCode)="backToOneTimeCodeFromSummary($event)">
  </app-summary>
</div>
